<template>
    <!-- Footer -->
    <footer class="footer bg-light">
        <loading :show="is_loading" :label="loading_label"></loading>
        <div class="container">
            <div class="row border-separator">
                <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
                    <ul class="list-inline mb-2">
                        <links-menu/>
                    </ul>
                    <p class="text-muted small mb-4 mb-lg-0">(14) 3815-3516 - Rua Hermínio Marco Calônego, 719JD Panorama - Botucatu - SP</p>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    import linksMenu from "./links-menu"
    import loading from 'vue-full-loading'
    import { mapState } from 'vuex'

    export default {
        name: "footer-default",
        components:{ linksMenu, loading },
        computed: {
            ...mapState({
                'is_loading': state => state.is_loading,
                'loading_label': state => state.loading_label,
            })
        }
    }
</script>

<style scoped>

</style>
